import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useForm } from "react-hook-form";

const AddParticipantModal = ({
    show,
    onHide,
    app_setup,
    event,
    participants,
    setParticipants,
    maxCount,
}) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    // ADD
    const onSubmit = (data) => {
        if (participants.length >= maxCount) return;

        setParticipants((prev) => [...prev, data]);
        reset();
    };

    // REMOVE
    const removeParticipant = (index) => {
        setParticipants((prev) => prev.filter((_, i) => i !== index));
    };

    const minChildrenAge = app_setup?.children_age;   // e.g. 12
    const isForKids = event?.Event?.for_child;              // true / false


    // console.log({ minChildrenAge, isForKids });



    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Participants ({participants.length}/{maxCount})
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                {/* PARTICIPANT LIST */}
                {participants.length > 0 && (
                    <div className="mb-3">
                        {participants.map((p, index) => (
                            <div
                                key={index}
                                className="d-flex justify-content-between align-items-center border p-2 mb-2 rounded"
                            >
                                <div>
                                    <strong>{p.name}</strong>
                                    <div className="text-muted small">
                                        Age: {p.age} | {p.gender}
                                    </div>
                                </div>

                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => removeParticipant(index)}
                                >
                                    Remove
                                </Button>
                            </div>
                        ))}
                    </div>
                )}

                {/* ADD FORM */}
                {participants.length < maxCount ? (
                    <Form>
                        <Form.Group className="mb-2">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                {...register("name", {
                                    required: "Full name is required",
                                    minLength: {
                                        value: 3,
                                        message: "Name must be at least 3 characters",
                                    },
                                    maxLength: {
                                        value: 50,
                                        message: "Name cannot exceed 50 characters",
                                    },
                                    pattern: {
                                        value: /^[A-Za-z\s]+$/,
                                        message: "Name can only contain letters and spaces",
                                    },
                                })}
                            />
                            <small className="text-danger">
                                {errors.name?.message}
                            </small>
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>Age</Form.Label>

                            <Form.Control
                                type="number"
                                inputMode="numeric"
                                maxLength={3}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, "");
                                }}
                                {...register("age", {
                                    required: "Age is required",
                                    setValueAs: (v) => (v === "" ? "" : Number(v)),
                                    min: {
                                        value: 1,
                                        message: "Age must be between 1 and 150",
                                    },
                                    max: {
                                        value: 150,
                                        message: "Age cannot be greater than 150",
                                    },
                                })}
                            />
                            <small className="text-danger">
                                {errors.age?.message}
                            </small>
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label>Gender</Form.Label>
                            <Form.Select
                                {...register("gender", {
                                    required: "Gender required",
                                })}
                            >
                                <option value="">Select</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </Form.Select>
                            <small className="text-danger">
                                {errors.gender?.message}
                            </small>
                        </Form.Group>
                    </Form>
                ) : (
                    <p className="text-danger text-center">
                        Maximum participant limit reached
                    </p>
                )}
            </Modal.Body>

            <Modal.Footer>
                {participants.length < maxCount && (
                    <Button onClick={handleSubmit(onSubmit)}>
                        Add Participant
                    </Button>
                )}
                <Button variant="secondary" onClick={onHide}>
                    Done
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddParticipantModal;
